export enum SentryTag {
  ErrorType = 'error_type',
  PaymentMethod = 'payment_method',
  Variant = 'variant',
  PaymentContextId = 'payment_context_id',
}
